import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CashbackTranslationEntity } from '../../domain/entities/CashbackTranslationEntity'

export class CashbackTranslationModel extends CashbackTranslationEntity {
  constructor(dataDto: CashbackTranslationEntity) {
    super()
    mapEntityProperties<CashbackTranslationEntity>(this, dataDto)
  }
}
